<div mat-dialog-title class="mb-3">
    <mat-chip-list>
      <mat-chip color="primary"  *ngFor="let test of selectedTests; let i = index"
      [matTooltip]="test.description" removable="true" (removed)="removeTest(i)" >
       {{test.id}}
       <mat-icon matChipRemove >cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
<div mat-dialog-content>
    <!--div class="row">
      <div class="col-12">
        <mat-form-field>
        <mat-label>Buscar</mat-label>
        <input matInput type="text" [formControl]="filter">
        <button mat-button *ngIf="filter.value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      </div>
      
    </div>

    <div class="row fixed-50">
      <div class="col-12">
        <table class="table table-hover table-sm">
              <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descripcion</th>
                <th scope="col">Material</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let test of list; let index;" (click)="selectTest(test, index)">
                <td>{{ test.id }}</td>
                <td>{{ test.description }}</td>
                <td>{{ test.specimenDescription }}</td>
              </tr>
              </tbody>
            </table>
      </div>       
    </div>

    <div class="row">
      <div class="col-12">
        <label>Análisis seleccionados</label>
        <div>
          <button type="button" class="btn btn-dark mb-1 mr-1" *ngFor="let test of selectedTests; let i = index" (click)="removeTest(i)">
            {{ test.id }}
          </button>
        </div>
      </div>
    </div-->
  
    <mat-tab-group mat-align-tabs="start" class="section-list">
      <mat-tab label="Analisis">

        <div class="row">
          <div class="col-6">
            <!-- SECCIONES -->
            <mat-form-field appearance="fill">
              <mat-label>Secciones</mat-label>
              <mat-select (selectionChange)="filterTests($event.value)">
                <mat-option  *ngFor="let section of sections" [value]="section" >{{section}}</mat-option>
              </mat-select>
            </mat-form-field>

            <!--div class="sections">
              <mat-selection-list #section [multiple]="false">
              <mat-list-option *ngFor="let section of sections" [value]="section" (click)="filterTests(section)">
                {{section}}
              </mat-list-option>
              </mat-selection-list>
            </div-->
            
          </div> 
          <div class="col-6">
            <mat-form-field>
            <mat-label>Buscar</mat-label>
            <input matInput type="text" [formControl]="filter">
            <button mat-button *ngIf="filter.value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          </div>                          
        </div>
        <div class="row">
          <div class="col-12">
            <!-- ANALISIS -->
            
              <table class="table table-hover table-sm mt-3"
                *ngIf="filteredTests.length > 0">
                <thead>
                <tr>
                  <th scope="col">Código</th>
                  <th scope="col">Descripcion</th>
                  <th scope="col">Material</th>
                </tr>
                </thead>
                <tbody class="tests">
                <tr *ngFor="let test of filteredTests; let index;" (click)="selectTest(test, index)">
                  <td>{{ test.id }}</td>
                  <td>{{ test.description }}</td>
                  <td>{{ test.specimenDescription }}</td>
                </tr>
                </tbody>
              </table>
            
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Perfiles">
        <table class="table table-hover table-sm mt-3">
        <thead>
        <tr>
          <th scope="col">Código</th>
          <th scope="col">Descripcion</th>
          <th scope="col">Material</th>
        </tr>
        </thead>
        <tbody class="tests">
        <tr *ngFor="let test of profiles; let index;" (click)="selectTest(test, index)">
          <td>{{ test.id }}</td>
          <td>{{ test.description }}</td>
          <td>{{ test.specimenDescription }}</td>
        </tr>
        </tbody>
      </table>
      </mat-tab>
      <mat-tab label="Favoritos">

      </mat-tab>
    </mat-tab-group>
  
  </div>

  <div mat-dialog-footer>
    
  </div>

  <mat-dialog-actions align="center">
    <button mat-raised-button [mat-dialog-close]="selectedTests" color="primary">Guardar</button>
    <button mat-raised-button mat-dialog-close color="warning">Cerrar</button>

  </mat-dialog-actions>

  <!--
      description: "Test de Prueba"
specimenId: "SUE"
testId: "AAA"
type: "A"
  -->